import { motion } from "framer-motion";
import { VALUES } from "@/data/content";

export const Values = () => {
  return (
    <section id="values" data-testid="values" className="py-20 md:py-32 px-5 md:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] text-white">
            What I value
          </h2>
          <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] text-yellow mt-1">
            from brands 🤝
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.label}
              initial={{ opacity: 0, y: 50, rotate: v.rotate * 2 }}
              whileInView={{ opacity: 1, y: 0, rotate: v.rotate }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ type: "spring", stiffness: 90, damping: 13, delay: (i % 2) * 0.1 }}
              whileHover={{ rotate: 0, scale: 1.03, y: -6 }}
              className="relative"
            >
              <div className="rounded-[2rem] overflow-hidden border-4 border-white shadow-2xl aspect-[4/5] bg-obsidian">
                <img
                  src={v.src}
                  alt={v.label}
                  className="h-full w-full object-cover"
                  loading="lazy"
                  data-testid={`value-img-${i}`}
                />
              </div>
              <div
                className={`absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-2xl px-6 py-3 shadow-xl ${
                  i % 2 ? "rotate-3" : "-rotate-3"
                }`}
              >
                <span className={`font-anton uppercase text-lg md:text-2xl whitespace-nowrap ${v.labelColor}`}>
                  {v.label} {v.emoji}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
